const PX_METRIC_DRAFT = /^\d*[.,]?\d*$/;

export const isIncompletePxDraft = (value) => /[.,]$/.test(String(value ?? ""));

export const parsePxMetricInput = (value) => {
  if (value === "" || value == null) return { kind: "empty" };
  const raw = String(value);
  if (!PX_METRIC_DRAFT.test(raw)) return { kind: "invalid" };
  if (isIncompletePxDraft(raw)) return { kind: "draft" };
  const parsed = Number(raw.replace(",", "."));
  if (!Number.isFinite(parsed) || parsed < 0) return { kind: "invalid" };
  return { kind: "number", value: parsed };
};

export const emitPxMetricChange = ({ key, value, onChangeField }) => {
  const parsed = parsePxMetricInput(value);
  if (parsed.kind === "invalid" || parsed.kind === "draft") return;
  onChangeField({
    key,
    value: parsed.kind === "empty" ? undefined : parsed.value,
  });
};

export const onPxMetricKeyDown = (event) => {
  if (event.ctrlKey || event.metaKey || event.altKey) return;
  const { key } = event;
  if (key.length !== 1) return;
  if (/^\d$/.test(key) || key === "." || key === ",") return;
  event.preventDefault();
};

export const pxMetricInputProps = {
  inputMode: "decimal",
  autoComplete: "off",
  onPaste: (event) => {
    const text = String(event.clipboardData?.getData("text") || "").trim();
    if (text !== "" && !PX_METRIC_DRAFT.test(text)) {
      event.preventDefault();
    }
  },
};
